// src/components/Onlinepayment.jsx
import React from "react";

export default function ClientsSectiomn({
  bgClass = "grey-bg",
  title = "Shree Swami Samarth PG offers a unique and Welcoming Environment that aims to make Residents Feel at Home.",
  heading = "Shree Swami Samarth PG ( Paying Guest )",
  text = "At Shree Swami Samarth PG, the emphasis is on creating comfortable living spaces.",
  primaryBtn = { label: "Book Now", href: "/contact.html", className: "theme-btn btn-style-four" },
  secondaryBtn = { label: "Contact Us", href: "/contact.html", className: "theme-btn btn-style-five" },
}) {
  return (
    <section className={`clients-section ${bgClass}`}>
      <div className="auto-container">
        <div className="title-box">
          <div className="title">{title}</div>
          <h2>{heading}</h2>
          <div className="text">{text}</div>
          <div className="btns-box">
            <a href={primaryBtn.href} className={primaryBtn.className}>
              {primaryBtn.label}
            </a>
            <a href={secondaryBtn.href} className={secondaryBtn.className}>
              {secondaryBtn.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
